<template>
    <div class="newsDetal">
        <navTop :isLogin="1" title="相君科技新闻资讯"></navTop>
        <div class="conent">
            <div class="news">
                <div class="title">{{newsData.title}}</div>
                <div class="time">发表日期：{{newsData.ct}}</div>
                <div class="message" v-html="newsData.content">

                </div>
                <div class="new_btn" v-show="$route.params.listId">
                    <div class="btn" @click="getBefore()" v-show="webData.before">上一条</div>
                    <div class="btn1" @click="getNext()" v-show="webData.next">下一条</div>
                </div>
            </div>
        </div>
        <navBom></navBom>
    </div>
</template>

<script>
    import navTop from '../../nav/nav-top.vue'
    import navBom from '../../nav/nav-bom.vue'

    export default {
        components: {
            navTop,
            navBom
        },
        data() {
            return {
                newsData: [],
                index: '',
                webData: []
            }
        },
        mounted() {
            if (!this.$route.params.minId) {
                this.$router.push('/');
            }
            if (this.$route.params.listId) {
                let id = this.$route.params.listId;
                id.forEach((item, index) => {
                    if (this.$route.params.minId == item) {
                        this.index = index
                    }
                })
            }

            this.getData();
        },

        methods: {
            getData() {
                let _this = this;
                let param = new FormData();
                param.append('id', _this.$route.params.minId);
                param.append('newsModuleId', _this.$route.params.bigId);
                _this.api.getdetailsAndBeforNext(param).then(res => {
                    console.log(res);
                    _this.webData = res.data;
                    _this.newsData = res.data.current;
                    _this.$route.params.listId.forEach((item, index) => {
                        if (item == res.data.current.id) {
                            _this.index = index;
                        }
                    })
                })

            },
            getNext() {
                let _this = this;
                let param = new FormData();
                _this.index += 1;
                console.log(_this.$route.params.listId.length);


                if (_this.index > _this.$route.params.listId.length - 1) {
                    _this.index = _this.$route.params.listId.length - 1;
                    _this.$message.info('当前已经是最后一条')
                } else {
                    param.append('id', _this.$route.params.listId[_this.index]);
                    param.append('newsModuleId', _this.$route.params.bigId);
                    param.append('type', '2');
                    _this.api.getdetailsAndBeforNext(param).then(res => {
                        console.log(res);
                        _this.webData = res.data;
                        _this.newsData = res.data.current;
                    })
                }

            },
            getBefore() {
                let _this = this;
                let param = new FormData();
                _this.index -= 1;

                if (_this.index < 0) {
                    _this.index = 0;
                    _this.$message.info('当前已经是第一条')
                } else {
                    param.append('id', _this.$route.params.listId[_this.index]);
                    param.append('newsModuleId', _this.$route.params.bigId);
                    param.append('type', '1');
                    _this.api.getdetailsAndBeforNext(param).then(res => {
                        console.log(res);
                        _this.webData = res.data;
                        _this.newsData = res.data.current;
                    })
                }

            },

        }
    }
</script>

<style scoped lang="less">
    @import '../../../../static/less/xm.less';

    .newsDetal {
        width: @a;
        height: auto;

        .conent {
            width: @a;
            height: auto;
            display: @flex;
            justify-content: center;
            padding: 2% 0;

            .news {
                width: 1400px;
                height: auto;

                .title {
                    width: @a;
                    height: 25px;
                    text-align: center;
                    font-family: MicrosoftYaHei-Bold;
                    font-size: 24px;
                    font-weight: bolder;
                    font-stretch: normal;
                    letter-spacing: 2px;
                    color: #333333;
                }

                .time {
                    width: auto;
                    height: 17px;
                    font-family: MicrosoftYaHei;
                    font-size: 16px;
                    font-weight: normal;
                    font-stretch: normal;
                    line-height: 36px;
                    letter-spacing: 0px;
                    color: #666666;
                    margin-left: 1030px;
                    margin-top: 20px;
                }

                .message {
                    width: @a;
                    height: auto;
                    margin-top: 47px;
                    letter-spacing: 1px;
                    color: #333333;
                    font-size: 18px;
                }

                .new_btn {
                    width: @a;
                    height: 50px;
                    margin-top: 70px;
                    overflow: hidden;
                    zoom: 1;

                    .btn:active {
                        background-image: linear-gradient(270deg,
                        #1e6eee 0%,
                        #109ee7 50%,
                        #01cee0 100%),
                        linear-gradient(#005bb0,
                        #005bb0);
                        background-blend-mode: normal,
                        normal;
                        box-shadow: 0px 0px 20px 0px rgba(33, 161, 219, 0.5);
                        color: #fff;
                    }

                    .btn {
                        width: 200px;
                        height: 50px;
                        line-height: 50px;
                        text-align: center;
                        background-color: #fff;
                        border: solid 1px #666666;
                        letter-spacing: 1px;
                        color: #333333;
                        cursor: pointer;
                        float: left;
                    }

                    .btn1:active {
                        background-image: linear-gradient(270deg,
                        #1e6eee 0%,
                        #109ee7 50%,
                        #01cee0 100%),
                        linear-gradient(#005bb0,
                        #005bb0);
                        background-blend-mode: normal,
                        normal;
                        box-shadow: 0px 0px 20px 0px rgba(33, 161, 219, 0.5);
                        color: #fff;
                    }

                    .btn1 {
                        width: 200px;
                        height: 50px;
                        line-height: 50px;
                        text-align: center;
                        background-color: #fff;
                        border: solid 1px #666666;
                        letter-spacing: 1px;
                        color: #333333;
                        cursor: pointer;
                        float: right;
                    }

                }
            }

        }
    }
</style>



// WEBPACK FOOTER //
// src/components/page/news/newsDetal.vue